<template>
  <div>
    <div class="uk-flex uk-flex-right uk-margin-top">
      <b-button color="red" @click="$modal.show('application-download')">
        <span uk-icon="icon: download; ratio: 1.2" class="download-icon" style="color: #fff"></span>
        <span style="margin-left: 10px">Выгрузить</span>
      </b-button>
    </div>
    <WrapperContent>
      <div class="uk-flex uk-flex-between uk-flex-bottom application__date-block">
        <div class="table-header uk-margin-remove-bottom">{{ header }}</div>
        <div class="uk-flex uk-flex-right">
          <div class="uk-flex uk-flex-column uk-flex-bottom">
            <b-datepicker
              ref="rangeDatepicker"
              range
              @input="filteredForDate"
              @clear="resetPickerDate"
            />
          </div>
        </div>
      </div>
      <b-table
        ref="tableComponent"
        :headers="headers"
        :columns="columns"
        :sort="'id'"
        :uri="uri"
        @clearRangeDate="resetTableDate"
      />
    </WrapperContent>
    <DownloadForm />
  </div>
</template>

<script>
import DownloadForm from './_dialogs/_download-form'
import {status} from '@/views/variables/application_status'

export default {
  name: 'ApplicationAdminList',
  components: {
    DownloadForm
  },
  data: () => ({
    uri: 'application/all',
    header: 'Список заявок',
    headers: [
      {name: '#', filter: {type: 'number', field: 'id', operator: ':'}},
      {name: 'Дата', minWidth: 150},
      {name: 'ФИО', filter: {type: 'text', field: 'fullName', operator: ':'}, minWidth: 200},
      {
        name: 'Контактные данные',
        filter: {type: 'number', field: 'phone', operator: ':', position: 'left-top'},
        minWidth: 220
      },
      {name: 'Адрес', minWidth: 230},
      {
        name: 'Статус',
        filter: {
          type: 'radio',
          field: 'status',
          operator: '~',
          values: status,
          position: 'left-top'
        },
        minWidth: 175
      },
      {name: '', filter: {type: 'clear'}}
    ],
    columns: [
      {name: 'id', type: Number},
      {name: 'applicationDate', type: 'date'},
      {name: 'fullName', type: String},
      {name: 'phone', unitedName: 'email', type: 'UnitedString'},
      {name: 'address', unitedName: 'communityName', type: 'UnitedString'},
      {name: 'status', type: 'applicationStatus', minWidth: 230},
      {name: '', type: ''}
    ],
    rangeDate: null
  }),
  methods: {
    filteredForDate(rangeVal) {
      let start = this.$moment(rangeVal[0]).format('YYYY-MM-DD')
      let end = this.$moment(rangeVal[1]).format('YYYY-MM-DD')
      this.rangeDate = [
        {
          name: 'startDate',
          operator: ':',
          value: start
        },
        {
          name: 'endDate',
          operator: ':',
          value: end
        }
      ]
      if (start !== 'Invalid date') this.$refs.tableComponent.filter(this.rangeDate)
    },
    resetTableDate() {
      this.$refs.rangeDatepicker.updateDate()
    },
    resetPickerDate() {
      this.rangeDate = [
        {
          name: 'startDate',
          operator: ':',
          value: ''
        },
        {
          name: 'endDate',
          operator: ':',
          value: ''
        }
      ]
      this.$refs.tableComponent.filter(this.rangeDate)
    }
  }
}
</script>
